/**
 * InteractiveGuide Articles container
 * Displaying the articles when user selected the ICF
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import _find from 'lodash/find';
import { Link } from 'react-router-dom';
import Loader from 'kepler/lib/components/Loader';

import { ICF_CONTENT } from '../constants/PropTypesShapes';
import { expandFAQContent, setICFAccessArticle } from '../actions/action-icf-page';
import Page from '../../lib/page';
import { downArrow, upArrow, check } from '../../lib/svgImages';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import l10n from '../../lib/reactPPl10nHelper';
import i18n from '../../lib/reacti18n';
import Breadcrumb from './Breadcrumb';
import ErrorPanel from '../components/ErrorPanel';
import UrlResources from '../constants/UrlResources';

import { setContextApiCall } from '../../contactUs/actions/action-article';
import { isSetContextEnabledFromRC } from '../../lib/omnichannelHelper';

const icf = {
  backBtn: l10n.getContent('smarthelp/home.home.back.icf.articles'),
  payPalGuide: i18n.message('smarthelp/home.home.payPalGuide'),
};

const exp = Page.getUserExperience();
const label = i18n.message(`smarthelp/contentToggle.content.label.desktop.${exp}`);

class icfArticlesContainer extends Component {
  // To form faq link for by FAQ id of solutionLink in the content
  static handleFAQClick(event) {
    const clickTarget = event.target;
    const faqID = clickTarget.id;

    if (faqID && clickTarget.name === 'solutionLink') {
      event.preventDefault();
      const target = clickTarget.target || '_self';
      window.open(Page.getArticleLink(faqID), target);
    }
  }

  static handleKeyPress(event) {
    if (event.which === 13) {
      icfArticlesContainer.handleFAQClick();
    }
  }

  // Get expansion article content style; hide/display the article content
  static getGuideArticleContainerStyle() {
    return classNames({
      'accordion-guide-article-container': true,
    });
  }

  constructor(props) {
    super(props);
    this.renderIcfArticles = this.renderIcfArticles.bind(this);
    this.backToHome = this.backToHome.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.icfList !== this.props.icfList && !this.props.isLoading && !this.props.error) {
      // FPTI for displaying the icf articles
      trackPage({ id: 'ICFPage', link: 'smarthelp-icf-articles', ...(this.props.icfList && this.props.icfList.length && { hpid: this.props.icfList[0].icf_id }) });
    }
  }

  handleLinkClick(e, link) {
    const icfArticleId = this.props.currentIcfId;
    const href = link.getAttribute('href');

    if (!href) {
      e.preventDefault();
      trackLink({ id: 'ICFPage', link: `smarthelp-icf-article|${icfArticleId}|broken-link-clicked` });
    } else {
      trackLink({ id: 'ICFPage', link: `smarthelp-icf-article|${icfArticleId}|link-clicked|${href}` });
    }
  }

  // using current ICF id to find the current ICF page defail from the list of ICF
  getCurrentICFContent() {
    return _find(this.props.icfList, (icfContent) => icfContent.icf_id === this.props.currentIcfId);
  }

  // Parsing images and videos in ICF article content
  parseICFArticleContent(content) {
    setTimeout(() => {
      if (!content) {
        return;
      }

      // Link click Tracking in Article Component
      const contentLinks = content.querySelectorAll('a[href]');
      Array.from(contentLinks).forEach((link) => {
        link.addEventListener('click', (e) => this.handleLinkClick(e, link));
      });

      // warp image in the article content
      let imageTags = content.getElementsByTagName('img');
      imageTags = Array.prototype.slice.call(imageTags);
      imageTags.forEach((tag) => {
        const divEl = document.createElement('img');
        divEl.setAttribute('src', tag.src);
        divEl.style.height = `${tag.height}px`;
        divEl.style.maxWidth = `${tag.width}px`;
        divEl.setAttribute('alt', tag.alt);
        divEl.className = 'okm-image';
        tag.parentNode.replaceChild(divEl, tag);
      });

      // rewarp Youtube video content
      let iframeTags = content.getElementsByTagName('iframe');
      iframeTags = Array.prototype.slice.call(iframeTags);
      iframeTags.forEach((tag) => {
        const videoEl = tag;
        videoEl.className = 'okm-paypal-iframe';
        videoEl.setAttribute('src', tag.src && tag.src.replace('youtube.com', 'youtube-nocookie.com'));
        tag.parentNode.replaceChild(videoEl, tag);
      });
    });

    const videoElement = document.querySelector('video');
    // If the video exist
    if (videoElement) {
      const articleId = (this.props.expandedFaqId) || '';
      trackPage({ id: 'icfArticlePageVideo', link: 'video-displayed', hpid: articleId });

      videoElement.addEventListener('play', () => {
        // When video is played firing FPTI
        trackLink({ id: 'icfArticlePageVideo', link: 'icf-article-page-video-played', hpid: articleId });
      });

      videoElement.addEventListener('pause', () => {
        // When video is paused firing FPTI
        trackLink({ id: 'icfArticlePageVideo', link: 'icf-article-page-video-paused', hpid: articleId });
      });
    }
  }

  // using current ICF id to find the current ICF page defail from the list of ICF
  keyPressHandler(event, article) {
    if (event.which === 13) {
      this.expandHandler(article);
    }
  }

  /**
   * Function to check tags information fron ICF Articles response and call setcontext API
   * @param article
   */
  icfSetContextTags(article) {
    // const elmoTreatmentEnabled = isPartOfElmoExpTreatment(elmoTreatments(), elmoTreatmentNames.omniChannelTreatmentEnabled);
    if (isSetContextEnabledFromRC() && Page.isLoggedIn() && Array.isArray(article.tags) && article.tags.length
      && Array.isArray(article.tags[0].predictions) && article.tags[0].predictions.length) {
      const articleTags = article.tags[0].predictions;
      // Parsing article repsonse by changing intent to customer_intent to pass to set context API
      const intents = articleTags.map(({ intent, score }) => ({ customer_intent: intent, score }));
      return this.props.setContextApiCall(intents, article.article_id);
    }
    return null;
  }

  // Click event when user click bullet point or one of the FAQ item
  expandHandler(article) {
    let clickEvent = 'icf-expansion';
    if (this.props.expandedFaqId === article.article_id) {
      // clicking on the same article changes fpti to collapse
      clickEvent = 'icf-collapse';
    }

    trackLink({ id: 'ICFPage', link: `click|${clickEvent}|${this.props.currentIcfId}|${article.article_id}`, hpid: `${article.article_id}` });
    const accessedICFArray = this.props.accessedList && this.props.accessedList.filter((ele) => ele.icfId === this.props.currentIcfId);

    // if there is no such entry add it
    if (Array.isArray(this.props.accessedList) && !accessedICFArray.length) {
      this.props.setICFAccessArticle(this.props.currentIcfId, article.article_id);
    } else {
      const accessedArticles = Array.isArray(accessedICFArray) && accessedICFArray[0] && accessedICFArray[0].accessed;
      if (Array.isArray(accessedArticles) && accessedArticles.indexOf(article.article_id) === -1) {
        this.props.setICFAccessArticle(this.props.currentIcfId, article.article_id);
      }
    }
    this.props.expandFAQContent(article.article_id, this.props.currentIcfId);

    // Checking tags in ICF Response only when expanding the icf article
    if (this.props.expandedFaqId !== article.article_id) {
      this.icfSetContextTags(article);
    }
  }

  backToHome() {
    trackLink({ id: 'ICFPage', link: 'icf-articles|back-btn|click', name: 'homePage' });
    this.props.expandFAQContent();
  }

  // Check whether the FAQ item are visited or not
  isVisited(article) {
    if (!article.article_id) {
      return false;
    }

    // Getting the ICF Visited articles from session
    let visitedArticlesInSession = (JSON.parse(window.sessionStorage.getItem('icfArticlesVisited')) || []);

    let accessedList = [];

    if (Array.isArray(visitedArticlesInSession) && visitedArticlesInSession.length > 0) {
      visitedArticlesInSession = visitedArticlesInSession.map((ele) => {
        // Parsing the objects if they are type string
        if (typeof ele === 'string') {
          return JSON.parse(ele);
        }
        return ele;
      });
      // Setting session visited articles to accessed list as the priority
      accessedList = visitedArticlesInSession;
    } else {
      // if window session visited articles are not available
      // taking the visited articles from props(which we get from req session)
      accessedList = this.props.accessedList;
    }

    if (Array.isArray(accessedList) && accessedList.length > 0) {
      // Get Accessed FAQ list within current ICF ID
      const accessed = _find(accessedList, (item) => item.icfId === this.props.currentIcfId);
      return accessed && Array.isArray(accessed.accessed) && accessed.accessed.indexOf(article.article_id) >= 0;
    }
    return null;
  }

  redirectToPreviousPage() {
    const { guideClicked } = this.props;
    if (!guideClicked) {
      if (Page.isMobileLayout()) {
        return <Breadcrumb items={[{ path: `/${UrlResources.PAYPALGUIDE}`, title: icf.payPalGuide }]} />;
      }
      // When icf articles are opened from paypal guide -> icf topic page
      return <Breadcrumb items={[{ path: '/home', title: label }, { path: `/${UrlResources.PAYPALGUIDE}`, title: icf.payPalGuide }]} />;
    }
    return <Link to="/home" onClick={() => this.backToHome()}>{icf.backBtn}</Link>;
  }

  renderArticleList(articles) {
    if (!Array.isArray(articles) || !articles.length) {
      return null;
    }

    return (articles.map((article, index) => (
      <div className={icfArticlesContainer.getGuideArticleContainerStyle(article)}>
        <div className="accordion-guide-article-content">
          {this.renderArticleTitle(article, index)}
          {this.renderArticleContent(article)}
        </div>
      </div>
    )));
  }

  renderArticleTitle(article, index) {
    // Default CheckBox article title style
    return (
      <div // eslint-disable-line jsx-a11y/no-static-element-interactions
        className="accordion-guide-article-header"
        tabIndex="0"
        onClick={() => this.expandHandler(article)}
        onKeyPress={(e) => this.keyPressHandler(e, article)}
      >
        <div className="accordion-guide-article-index">
          {this.renderCheckBoxIconStyle(index, article)}
        </div>
        <h3 className="accordion-guide-article-title">
          {article.title}
        </h3>
        <div className="accordion-guide-article-arrow">
          {this.props.expandedFaqId !== article.article_id ? downArrow : upArrow}
        </div>
      </div>
    );
  }

  renderArticleContent(article) {
    if (this.props.expandedFaqId !== article.article_id) {
      return null;
    }

    return (
      <div // eslint-disable-line jsx-a11y/no-static-element-interactions
        className="accordion-guide-article-body"
        ref={(el) => { this.parseICFArticleContent(el); }}
        onClick={(event) => icfArticlesContainer.handleFAQClick(event)}
        onKeyPress={(event) => icfArticlesContainer.handleKeyPress(event)}
      >
        {Page.getHTMLElement({ message: article.article_content, useHTML: true })}
      </div>
    );
  }

  // Return Icon style in the CheckBox version style
  renderCheckBoxIconStyle(index, article) {
    // Return index number if the article is not visited
    if (!this.isVisited(article)) {
      return (
        <span className="accordion-guide-article-icon">
          {index + 1}
        </span>
      );
    }

    // Return green check icon if the article is visited
    return (
      <span className="accordion-guide-article-icon__visited">
        {check}
      </span>
    );
  }

  renderIcfArticles() {
    const { isLoading, error, currentIcfId } = this.props;
    if (isLoading) {
      return <Loader show type="fixed" />;
    }
    if (error) {
      trackPage({ id: 'ICFPageError', link: 'smarthelp-icf-articles-error', hpid: currentIcfId });
      return <ErrorPanel pageName="icfArticlesErrorPage" />;
    }
    const ICFcontent = this.getCurrentICFContent();
    if (!ICFcontent || !ICFcontent.icf_id) {
      return null;
    }

    // Adding page title for icf articles
    Page.setDocumentTitle(ICFcontent.icf_title);

    return (
      <div className="accordion-guide-content">
        {this.redirectToPreviousPage()}
        <h2 className="accordion-guide-title">{ICFcontent.icf_title}</h2>
        <div className="accordion-guide-summary">{ICFcontent.icf_summary}</div>
        {this.renderArticleList(ICFcontent.articles)}
      </div>
    );
  }

  render() {
    return this.renderIcfArticles();
  }
}

icfArticlesContainer.propTypes = {
  icfList: PropTypes.arrayOf(PropTypes.shape(ICF_CONTENT)),
  currentIcfId: PropTypes.string,
  expandFAQContent: PropTypes.func.isRequired,
  expandedFaqId: PropTypes.string,
  setICFAccessArticle: PropTypes.func.isRequired,
  accessedList: PropTypes.arrayOf(PropTypes.shape(ICF_CONTENT)),
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.bool,
  guideClicked: PropTypes.bool,
  setContextApiCall: PropTypes.func.isRequired,
};

icfArticlesContainer.defaultProps = {
  icfList: [],
  accessedList: [],
  expandedFaqId: '',
  currentIcfId: '',
  error: false,
  guideClicked: false,
};

function mapStateToProps(state) {
  return {
    icfSelected: state.icfGuide.isIcfSelected,
    icfList: state.icfGuide.icfArticleList,
    currentIcfId: state.icfPage.currentIcfId,
    expandedFaqId: state.icfPage.expandedFaqId,
    accessedList: state.icfPage.accessedList,
    isLoading: state.icfGuide.icfArticleIsLoading,
    error: state.icfGuide.icfArticleError,
    guideClicked: state.icfPage.guideClicked,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ expandFAQContent, setICFAccessArticle, setContextApiCall }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(icfArticlesContainer);
